// List of basemap menu types.
export const BASEMAP_MENU_TYPE_BASEMAPS = 'basemaps';
export const BASEMAP_MENU_TYPE_ADDONS = 'addons';
